export default "__VITE_ASSET__B29CXs5R__"